export default __webpack_public_path__ + "static/media/playpass.61afd6de.png";